import {useBreadcrumbs} from '@/hooks/useBreadcrumbs';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/shadcn_components/ui/breadcrumb';
import useAppSettingStore from '@/store/useAppSettingStore';
import {ReactNode, useEffect, useMemo} from 'react';
import {Link} from 'react-router-dom';

function AppBreadcrumbs() {
  const crumbs = useBreadcrumbs();
  const {generalSettings} = useAppSettingStore();

  useEffect(() => {
    document.title =
      (generalSettings.site_name ? generalSettings.site_name + ': ' : '') +
      crumbs
        .filter(v => typeof v.label === 'string')
        .map(v => v.label)
        .join(' - ');
  }, [crumbs]);

  const breadcrumbList = useMemo(() => {
    const listNode: ReactNode[] = [];
    for (let i = 0; i < crumbs.length; i++) {
      const crumb = crumbs[i];
      if (crumb.path && i != crumbs.length - 1) {
        listNode.push(
          <BreadcrumbItem key={i}>
            <Link
              to={crumb.path}
              key={i}
              className="truncate max-w-[200px] text-lg hover:text-primary whitespace-nowrap overflow-hidden text-ellipsis">
              {crumb.label}
            </Link>
          </BreadcrumbItem>,
        );
        listNode.push(<BreadcrumbSeparator key={'after_' + i} />);
      } else {
        listNode.push(
          <BreadcrumbItem key={i}>
            <span className="truncate max-w-[200px] text-lg whitespace-nowrap overflow-hidden text-ellipsis">{crumb.label}</span>
          </BreadcrumbItem>,
        );
      }
    }
    return listNode;
  }, [crumbs]);

  return (
    <Breadcrumb className="bg-transparent">
      <BreadcrumbList>{breadcrumbList}</BreadcrumbList>
    </Breadcrumb>
  );
}

export default AppBreadcrumbs;
